import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AdminDeleteDesignationRes;
export const AdminDeleteDesignationTodo = createAsyncThunk('AdminDeleteDesignation', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `admin/designation_admin/${id}`,
            params: {
                "company_id": localStorage.getItem('companyId')
            },
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AdminDeleteDesignationRes = res.data
        
    } catch (error) {
        return AdminDeleteDesignationRes = error.response.data
    }
})
